export enum ServiceCallType {
    Default,
    YKioskHOTEL
}
